const style = { height: "auto", width: "24px" };
const logoStyle = { height: "auto", width: "3rem" };
const notFound = { height: "auto", width: "280px" };
export const HomeIcon = () => {
  return (
    <svg
      id="home_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_18" data-name="Path 18" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_19"
        data-name="Path 19"
        d="M10,20V14h4v6h5V12h3L12,3,2,12H5v8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PlaylistIcon = () => {
  return (
    <svg
      id="queue_music_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <g id="Group_1" data-name="Group 1">
        <rect
          id="Rectangle_35"
          data-name="Rectangle 35"
          width="24"
          height="24"
          fill="none"
        />
      </g>
      <g id="Group_2" data-name="Group 2">
        <path
          id="Path_20"
          data-name="Path 20"
          d="M15,6H3V8H15Zm0,4H3v2H15ZM3,16h8V14H3ZM17,6v8.18A3,3,0,1,0,19,17V8h3V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const HistoryIcon = () => {
  return (
    <svg
      id="history_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_16" data-name="Path 16" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_17"
        data-name="Path 17"
        d="M13,3a9,9,0,0,0-9,9H1l3.89,3.89.07.14L9,12H6a7.034,7.034,0,1,1,2.06,4.94L6.64,18.36A9,9,0,1,0,13,3ZM12,8v5l4.28,2.54L17,14.33l-3.5-2.08V8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      id="bookmark_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_14" data-name="Path 14" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_15"
        data-name="Path 15"
        d="M17,3H7A2.006,2.006,0,0,0,5,5V21l7-3,7,3V5A2.006,2.006,0,0,0,17,3Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LikeIcon = () => {
  return (
    <svg
      id="thumb_up_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_21" data-name="Path 21" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_22"
        data-name="Path 22"
        d="M1,21H5V9H1ZM23,10a2.006,2.006,0,0,0-2-2H14.69l.95-4.57.03-.32a1.505,1.505,0,0,0-.44-1.06L14.17,1,7.59,7.59A1.955,1.955,0,0,0,7,9V19a2.006,2.006,0,0,0,2,2h9a1.987,1.987,0,0,0,1.84-1.22l3.02-7.05A1.976,1.976,0,0,0,23,12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DislikeIcon = () => {
  return (
    <svg
      id="thumb_down_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_24" data-name="Path 24" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_25"
        data-name="Path 25"
        d="M15,3H6A1.987,1.987,0,0,0,4.16,4.22L1.14,11.27A1.976,1.976,0,0,0,1,12v2a2.006,2.006,0,0,0,2,2H9.31l-.95,4.57-.03.32a1.505,1.505,0,0,0,.44,1.06L9.83,23l6.59-6.59A1.987,1.987,0,0,0,17,15V5A2.006,2.006,0,0,0,15,3Zm4,0V15h4V3Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--foreground)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-x">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};
export const ThreeDotsIcon = () => {
  return (
    <svg
      id="more_vert_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_26" data-name="Path 26" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_27"
        data-name="Path 27"
        d="M12,8a2,2,0,1,0-2-2A2.006,2.006,0,0,0,12,8Zm0,2a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,16Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PlaylistAddIcon = () => {
  return (
    <svg
      id="playlist_add_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <g id="Group_3" data-name="Group 3">
        <rect
          id="Rectangle_36"
          data-name="Rectangle 36"
          width="24"
          height="24"
          fill="none"
        />
      </g>
      <g id="Group_4" data-name="Group 4">
        <path
          id="Path_23"
          data-name="Path 23"
          d="M14,10H3v2H14Zm0-4H3V8H14Zm4,8V10H16v4H12v2h4v4h2V16h4V14ZM3,16h7V14H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const HamBurger = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} viewBox="0 0 20 14">
      <g id="menu_1_" data-name="menu (1)" transform="translate(-2 -5)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="18"
          transform="translate(3 12)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x2="18"
          transform="translate(3 6)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_3"
          data-name="Line 3"
          x2="18"
          transform="translate(3 18)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      id="edit_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_28" data-name="Path 28" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_29"
        data-name="Path 29"
        d="M14.06,9.02l.92.92L5.92,19H5v-.92l9.06-9.06M17.66,3a1,1,0,0,0-.7.29L15.13,5.12l3.75,3.75,1.83-1.83a1,1,0,0,0,0-1.41L18.37,3.29A.982.982,0,0,0,17.66,3Zm-3.6,3.19L3,17.25V21H6.75L17.81,9.94,14.06,6.19Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Logo = () => {
  return (
    <svg
      viewBox="0 0 174 40"
      style={{ height: "auto", width: "12rem" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M5.98064 25.3534C5.78603 25.1925 5.53576 25.1148 5.28422 25.1374C5.03269 25.1599 4.80021 25.2808 4.63732 25.4738C4.47443 25.6668 4.3943 25.9163 4.41433 26.168C4.43436 26.4198 4.55294 26.6535 4.74429 26.8183L12.7581 33.5876V37.5415C11.2301 37.4613 9.73279 37.0806 8.35206 36.421C6.97133 35.7615 5.73424 34.8361 4.71165 33.6978C0.0763498 28.2954 2.2267 20.5345 4.85038 14.977C6.19282 12.133 8.49007 8.8524 10.5425 6.24096C10.6934 6.04028 10.7596 5.78841 10.7269 5.53945C10.6942 5.29048 10.5652 5.06426 10.3676 4.90936C10.17 4.75445 9.91946 4.68322 9.66989 4.71095C9.42032 4.73867 9.19157 4.86315 9.03276 5.05766C6.91913 7.74662 4.53211 11.1537 3.11622 14.1569C-0.992706 22.8644 -0.943742 30.054 3.25496 34.9464C5.70318 37.7985 9.47752 39.4592 13.6068 39.5H13.615C13.8884 39.4916 14.1487 39.3808 14.3444 39.1896C14.5401 38.9985 14.6569 38.7409 14.6718 38.4677V33.1469C14.6724 33.0078 14.6424 32.8702 14.5838 32.744C14.5253 32.6178 14.4397 32.506 14.3332 32.4165L5.98064 25.3534Z"
          fill="#4D822B"
        />
        <path
          d="M20.6251 19.3226L13.7293 24.9004L6.76815 19.1675C6.57174 19.0057 6.31909 18.9286 6.06581 18.9531C5.81252 18.9776 5.57934 19.1017 5.41755 19.2981C5.25576 19.4945 5.17863 19.7471 5.20312 20.0004C5.2276 20.2537 5.35171 20.4869 5.54812 20.6487C5.65421 20.7384 13.056 26.8386 13.1702 26.9202C13.3397 27.042 13.5445 27.1047 13.7531 27.0988C13.9617 27.0929 14.1627 27.0187 14.325 26.8876L21.8329 20.816C22.0254 20.6541 22.1468 20.4231 22.1708 20.1727C22.1949 19.9222 22.1198 19.6724 21.9616 19.4768C21.8034 19.2812 21.5747 19.1554 21.3248 19.1266C21.0749 19.0978 20.8237 19.1681 20.6251 19.3226V19.3226Z"
          fill="#4D822B"
        />
        <path
          d="M8.75938 13.9651C8.56783 13.7984 8.31793 13.7147 8.06464 13.7323C7.81135 13.7499 7.57543 13.8674 7.40877 14.0589C7.24212 14.2505 7.15838 14.5004 7.17598 14.7537C7.19358 15.007 7.31108 15.2429 7.50262 15.4095L9.79171 17.3967C9.88655 17.4792 9.99672 17.5422 10.1159 17.5822C10.2351 17.6221 10.361 17.6382 10.4864 17.6295C10.6119 17.6207 10.7343 17.5874 10.8469 17.5314C10.9594 17.4753 11.0598 17.3977 11.1423 17.3028C11.2248 17.208 11.2879 17.0978 11.3278 16.9786C11.3677 16.8594 11.3838 16.7335 11.3751 16.6081C11.3664 16.4827 11.3331 16.3602 11.277 16.2477C11.221 16.1351 11.1433 16.0347 11.0485 15.9522L8.75938 13.9651Z"
          fill="#4D822B"
        />
        <path
          d="M16.3815 31.225C16.4613 31.3226 16.5595 31.4035 16.6706 31.4631C16.7817 31.5228 16.9034 31.5599 17.0289 31.5724C17.1543 31.5849 17.281 31.5725 17.4017 31.536C17.5223 31.4995 17.6346 31.4396 17.7321 31.3596L23.2243 26.8794C23.4212 26.7181 23.5461 26.4853 23.5713 26.232C23.5966 25.9787 23.5202 25.7257 23.3589 25.5288C23.1977 25.3318 22.9648 25.207 22.7115 25.1817C22.4582 25.1565 22.2053 25.2329 22.0083 25.3941L16.5161 29.8744C16.32 30.0362 16.1958 30.2689 16.1706 30.5219C16.1454 30.7749 16.2212 31.0276 16.3815 31.225V31.225Z"
          fill="#4D822B"
        />
        <path
          d="M24.3301 14.1568C21.7349 8.65649 15.7898 1.97285 14.4637 0.35294C14.3331 0.193904 14.1547 0.0811733 13.9549 0.0314404C13.7552 -0.0182924 13.5448 -0.0023823 13.3548 0.0768135C13.1648 0.156009 13.0054 0.294281 12.9001 0.471153C12.7949 0.648025 12.7494 0.854094 12.7704 1.05884C12.7459 1.20574 12.7541 0.144841 12.7541 19.2246C12.7615 19.4104 12.8202 19.5905 12.9237 19.745C13.0271 19.8994 13.1712 20.0223 13.3401 20.1C13.509 20.1777 13.6961 20.2072 13.8807 20.1852C14.0653 20.1632 14.2403 20.0906 14.3862 19.9754L20.0661 15.4911C20.2611 15.3321 20.3858 15.1028 20.4133 14.8527C20.4408 14.6026 20.3689 14.3517 20.2131 14.1541C20.0573 13.9566 19.8301 13.8281 19.5804 13.7966C19.3308 13.765 19.0788 13.8329 18.8787 13.9855L14.6718 17.3069V3.58051C16.9609 6.32252 20.7312 11.019 22.5959 14.977C25.2196 20.5385 27.3699 28.2994 22.7346 33.6977C21.2657 35.4115 19.6703 36.6233 17.3159 37.2027C17.1922 37.2313 17.0754 37.2841 16.9723 37.3582C16.8692 37.4323 16.7818 37.5261 16.7153 37.6342C16.6487 37.7423 16.6044 37.8626 16.5847 37.988C16.5651 38.1135 16.5705 38.2415 16.6008 38.3648C16.6311 38.4881 16.6856 38.6042 16.7611 38.7062C16.8366 38.8083 16.9317 38.8943 17.0407 38.9593C17.1498 39.0243 17.2707 39.067 17.3964 39.0848C17.5221 39.1027 17.6501 39.0954 17.7729 39.0634C20.5149 38.3861 22.4531 36.962 24.1832 34.9463C28.39 30.0539 28.439 22.8643 24.3301 14.1568Z"
          fill="#4D822B"
        />
        <path
          d="M46.029 18.2381H49.6051V24.164C48.7477 24.769 47.7943 25.2249 46.7851 25.5125C45.7507 25.8216 44.6771 25.9798 43.5976 25.9822C42.1911 26.004 40.8011 25.6776 39.5515 25.0319C38.3845 24.4283 37.4081 23.5124 36.7315 22.3862C36.0426 21.2246 35.6895 19.8948 35.7114 18.5445C35.6895 17.1942 36.0426 15.8643 36.7315 14.7028C37.4122 13.5725 38.3963 12.6558 39.5719 12.0567C40.8428 11.4094 42.253 11.0831 43.6792 11.1064C44.9113 11.0873 46.1345 11.3172 47.2756 11.7825C48.304 12.2071 49.2151 12.873 49.9319 13.7239L47.3572 16.0534C46.9289 15.5511 46.3962 15.1483 45.7961 14.873C45.1961 14.5977 44.5433 14.4567 43.8832 14.4596C43.3397 14.4354 42.7969 14.5216 42.2876 14.713C41.7783 14.9044 41.3131 15.197 40.92 15.5732C40.5394 15.9656 40.2433 16.432 40.05 16.9434C39.8567 17.4548 39.7704 18.0004 39.7963 18.5465C39.7833 19.2835 39.9592 20.0116 40.3071 20.6614C40.6372 21.2706 41.1332 21.7737 41.7377 22.1124C42.3815 22.4675 43.1073 22.6472 43.8424 22.6334C44.5968 22.6382 45.3432 22.4778 46.029 22.1634V18.2381ZM55.6946 15.9494C56.0976 15.4396 56.6305 15.0478 57.2374 14.8154C57.9323 14.5525 58.671 14.4243 59.4139 14.4376V17.932C59.1224 17.8954 58.8291 17.875 58.5354 17.8708C57.8213 17.829 57.1196 18.0715 56.5837 18.5453C56.3309 18.8225 56.1378 19.1488 56.0165 19.5039C55.8952 19.8589 55.8483 20.2352 55.8786 20.6092V25.6966H51.9958V14.6212H55.6942L55.6946 15.9494ZM72.2279 20.1791C72.2279 20.2063 72.2075 20.5265 72.1667 21.1396H64.1136C64.2555 21.6818 64.5943 22.1517 65.064 22.4576C65.5953 22.7808 66.21 22.9407 66.8316 22.9174C67.3012 22.9278 67.7687 22.8516 68.2107 22.6926C68.6416 22.5168 69.039 22.2683 69.3859 21.9581L71.4293 24.0832C70.3529 25.2815 68.7794 25.8806 66.7088 25.8806C65.5295 25.9062 64.3607 25.6546 63.2963 25.1461C62.3585 24.6942 61.5683 23.9851 61.0179 23.1014C60.4743 22.2098 60.1944 21.1824 60.2108 20.1383C60.1951 19.1067 60.4675 18.0913 60.9975 17.2061C61.522 16.341 62.2751 15.6374 63.1739 15.1729C64.1394 14.6735 65.2135 14.4212 66.3003 14.4384C67.3419 14.4242 68.3718 14.6589 69.3043 15.1231C70.1901 15.5672 70.9309 16.2549 71.4395 17.1053C71.9821 18.0371 72.255 19.1013 72.2279 20.1791V20.1791ZM66.3207 17.1959C65.7746 17.1777 65.2405 17.3593 64.8187 17.7068C64.407 18.0647 64.1355 18.557 64.0524 19.0962H68.5886C68.5052 18.5568 68.2332 18.0645 67.8211 17.7068C67.3997 17.3597 66.8663 17.1781 66.3207 17.1959V17.1959ZM85.345 20.1795C85.345 20.2067 85.3246 20.5269 85.2838 21.14H77.2324C77.3743 21.6822 77.7131 22.1521 78.1827 22.458C78.7141 22.7812 79.3288 22.9411 79.9504 22.9178C80.42 22.9282 80.8875 22.852 81.3295 22.693C81.7604 22.5172 82.1578 22.2687 82.5047 21.9585L84.5481 24.0836C83.472 25.2816 81.8985 25.8806 79.8275 25.8806C78.6483 25.9062 77.4794 25.6546 76.4151 25.1461C75.4773 24.6942 74.6871 23.9851 74.1367 23.1014C73.5931 22.2098 73.3132 21.1824 73.3296 20.1383C73.3138 19.1067 73.5863 18.0913 74.1163 17.2061C74.6408 16.341 75.3939 15.6374 76.2927 15.1729C77.2582 14.6735 78.3323 14.4212 79.4191 14.4384C80.4607 14.4242 81.4906 14.6589 82.4231 15.1231C83.3089 15.5672 84.0497 16.2549 84.5583 17.1053C85.1003 18.0373 85.3726 19.1014 85.345 20.1791V20.1795ZM79.4395 17.1959C78.8933 17.1777 78.3593 17.3593 77.9375 17.7068C77.5258 18.0647 77.2543 18.557 77.1712 19.0962H81.7078C81.6247 18.557 81.3532 18.0647 80.9415 17.7068C80.5197 17.3593 79.9857 17.1777 79.4395 17.1959V17.1959ZM94.3565 14.4372C94.9637 14.4092 95.5703 14.5031 96.1407 14.7133C96.711 14.9235 97.2334 15.2459 97.6771 15.6613C98.515 16.4774 98.9339 17.7102 98.9339 19.3598V25.6966H95.0514V19.9955C95.0514 18.4833 94.4452 17.7272 93.2328 17.7272C92.9342 17.7142 92.6363 17.7658 92.3595 17.8785C92.0827 17.9911 91.8334 18.1622 91.6288 18.3801C91.1874 18.9345 90.9721 19.6353 91.0261 20.3419V25.6966H87.1436V14.6212H90.8421V15.827C91.2801 15.376 91.8097 15.0242 92.3951 14.795C93.0201 14.5518 93.6859 14.4304 94.3565 14.4372V14.4372ZM101.365 14.6212H105.248V25.6966H101.366L101.365 14.6212ZM103.307 13.3971C102.68 13.426 102.066 13.214 101.59 12.8046C101.381 12.6219 101.214 12.3955 101.101 12.1413C100.988 11.8871 100.932 11.6113 100.937 11.3333C100.932 11.0552 100.988 10.7794 101.101 10.5252C101.214 10.271 101.381 10.0446 101.59 9.86188C102.066 9.45251 102.68 9.24054 103.307 9.26941C103.929 9.24017 104.539 9.4401 105.023 9.83128C105.234 10.0065 105.402 10.2272 105.515 10.4767C105.628 10.7263 105.683 10.9982 105.676 11.2721C105.684 11.5579 105.629 11.8419 105.517 12.1047C105.404 12.3675 105.236 12.6028 105.023 12.7944C104.55 13.2091 103.935 13.4244 103.307 13.3951V13.3971ZM111.991 15.0317H114.627V17.9333H112.093V25.6966H108.211V17.9316H106.597V15.0301H108.211V14.7444C108.181 14.1547 108.274 13.5651 108.483 13.0129C108.692 12.4607 109.014 11.9578 109.427 11.5361C110.238 10.7472 111.372 10.3527 112.829 10.3527C113.31 10.3518 113.789 10.3998 114.26 10.496C114.663 10.5691 115.05 10.7145 115.402 10.9252L114.444 13.6595C114.091 13.4497 113.689 13.3371 113.279 13.333C113.103 13.3224 112.928 13.3497 112.764 13.4131C112.6 13.4765 112.451 13.5744 112.328 13.7003C112.083 14.0057 111.963 14.3926 111.991 14.7832V15.0317ZM127.93 14.6237L123.151 26.1454C122.592 27.5077 121.911 28.4647 121.107 29.0163C120.235 29.5881 119.207 29.8771 118.165 29.8438C117.565 29.8417 116.969 29.7487 116.397 29.568C115.875 29.4202 115.386 29.1739 114.956 28.8425L116.305 26.1246C116.533 26.3351 116.8 26.4983 117.092 26.6049C117.388 26.7189 117.703 26.7778 118.021 26.7787C118.34 26.7914 118.655 26.7134 118.931 26.5538C119.193 26.3756 119.401 26.1285 119.532 25.8398L114.791 14.6212H118.776L121.494 21.3848L124.232 14.6212L127.93 14.6237Z"
          fill="var(--foreground)"
        />
      </g>
      <path
        d="M138.02 12.4C139.16 12.4 140.15 12.592 140.99 12.976C141.83 13.348 142.478 13.888 142.934 14.596C143.39 15.292 143.618 16.114 143.618 17.062C143.618 18.01 143.39 18.832 142.934 19.528C142.478 20.224 141.83 20.764 140.99 21.148C140.15 21.52 139.16 21.706 138.02 21.706H135.824V25H132.26V12.4H138.02ZM137.804 18.898C138.536 18.898 139.088 18.742 139.46 18.43C139.832 18.106 140.018 17.65 140.018 17.062C140.018 16.474 139.832 16.018 139.46 15.694C139.088 15.37 138.536 15.208 137.804 15.208H135.824V18.898H137.804ZM145.369 11.644H148.789V25H145.369V11.644ZM155.17 15.082C156.79 15.082 158.026 15.454 158.878 16.198C159.73 16.93 160.156 18.058 160.156 19.582V25H156.97V23.74C156.478 24.688 155.518 25.162 154.09 25.162C153.334 25.162 152.68 25.03 152.128 24.766C151.576 24.502 151.156 24.148 150.868 23.704C150.592 23.248 150.454 22.732 150.454 22.156C150.454 21.232 150.808 20.518 151.516 20.014C152.224 19.498 153.316 19.24 154.792 19.24H156.736C156.676 18.208 155.986 17.692 154.666 17.692C154.198 17.692 153.724 17.77 153.244 17.926C152.764 18.07 152.356 18.274 152.02 18.538L150.868 16.216C151.408 15.856 152.062 15.58 152.83 15.388C153.61 15.184 154.39 15.082 155.17 15.082ZM155.044 23.002C155.44 23.002 155.788 22.906 156.088 22.714C156.388 22.522 156.604 22.24 156.736 21.868V21.022H155.26C154.264 21.022 153.766 21.352 153.766 22.012C153.766 22.312 153.88 22.552 154.108 22.732C154.336 22.912 154.648 23.002 155.044 23.002ZM172.417 15.244L168.205 25.396C167.713 26.596 167.113 27.436 166.405 27.916C165.697 28.408 164.833 28.654 163.813 28.654C163.297 28.654 162.775 28.57 162.247 28.402C161.731 28.246 161.311 28.036 160.987 27.772L162.175 25.378C162.367 25.558 162.595 25.696 162.859 25.792C163.135 25.9 163.411 25.954 163.687 25.954C164.011 25.954 164.275 25.888 164.479 25.756C164.695 25.624 164.875 25.414 165.019 25.126L160.843 15.244H164.353L166.747 21.202L169.159 15.244H172.417Z"
        fill="#E4B601"
      />
      <defs>
        <clipPath id="clip0">
          <rect width="128" height="39.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LogoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={logoStyle}
      viewBox="0 0 66.92 96.805">
      <g
        id="Group_6"
        data-name="Group 6"
        transform="translate(-42.224 -64.405)">
        <path
          id="Path_30"
          data-name="Path 30"
          d="M56.71,126.54a2.349,2.349,0,0,0-3.03,3.59l19.64,16.59v9.69a28.516,28.516,0,0,1-19.72-9.42c-11.36-13.24-6.09-32.26.34-45.88,3.29-6.97,8.92-15.01,13.95-21.41a2.351,2.351,0,0,0-3.7-2.9c-5.18,6.59-11.03,14.94-14.5,22.3-10.07,21.34-9.95,38.96.34,50.95,6,6.99,15.25,11.06,25.37,11.16h.02a2.677,2.677,0,0,0,2.59-2.53V145.64a2.324,2.324,0,0,0-.83-1.79Z"
          fill="#4d822b"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M92.6,111.76,75.7,125.43,58.64,111.38a2.351,2.351,0,1,0-2.99,3.63c.26.22,18.4,15.17,18.68,15.37a2.335,2.335,0,0,0,2.83-.08l18.4-14.88a2.354,2.354,0,0,0-2.96-3.66Z"
          fill="#4d822b"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M63.52,98.63a2.346,2.346,0,0,0-3.08,3.54l5.61,4.87a2.346,2.346,0,1,0,3.08-3.54Z"
          fill="#4d822b"
        />
        <path
          id="Path_33"
          data-name="Path 33"
          d="M82.2,140.93a2.35,2.35,0,0,0,3.31.33l13.46-10.98a2.352,2.352,0,0,0-2.98-3.64L82.53,137.62A2.361,2.361,0,0,0,82.2,140.93Z"
          fill="#4d822b"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M101.68,99.1C95.32,85.62,80.75,69.24,77.5,65.27A2.348,2.348,0,0,0,73.35,67c-.06.36-.04-2.24-.04,44.52a2.471,2.471,0,0,0,4,1.84l13.92-10.99a2.35,2.35,0,0,0-2.91-3.69l-10.31,8.14V73.18c5.61,6.72,14.85,18.23,19.42,27.93,6.43,13.63,11.7,32.65.34,45.88-3.6,4.2-7.51,7.17-13.28,8.59a2.348,2.348,0,1,0,1.12,4.56c6.72-1.66,11.47-5.15,15.71-10.09C111.63,138.06,111.75,120.44,101.68,99.1Z"
          fill="#4d822b"
        />
      </g>
    </svg>
  );
};

export const VisibleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
    </svg>
  );
};
export const VisibleOffIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path
        d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
        fill="none"
      />
      <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z" />
    </svg>
  );
};
export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};
export const Moon = () => {
  return (
    <svg
      id="moon"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <rect
        id="Rectangle_1"
        data-name="Rectangle 1"
        width="24"
        height="24"
        fill="none"
      />
      <path
        id="Path_1"
        data-name="Path 1"
        d="M12,3a9,9,0,1,0,9,9,10.122,10.122,0,0,0-.1-1.36A5.4,5.4,0,1,1,13.36,3.1,10.122,10.122,0,0,0,12,3Z"
        fill="#45576f"
      />
    </svg>
  );
};
export const Sun = () => {
  return (
    <svg
      id="wb_sunny_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_2" data-name="Path 2" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_3"
        data-name="Path 3"
        d="M6.76,4.84,4.96,3.05,3.55,4.46,5.34,6.25ZM4,10.5H1v2H4ZM13,.55H11V3.5h2V.55Zm7.45,3.91L19.04,3.05,17.25,4.84l1.41,1.41Zm-3.21,13.7,1.79,1.8,1.41-1.41-1.8-1.79-1.4,1.4ZM20,10.5v2h3v-2Zm-8-5a6,6,0,1,0,6,6A6,6,0,0,0,12,5.5ZM11,22.45h2V19.5H11ZM3.55,18.54l1.41,1.41,1.79-1.8L5.34,16.74Z"
        fill="var(--foreground)"
      />
    </svg>
  );
};
export const NotFound = () => {
  return (
    <svg
      style={notFound}
      viewBox="0 0 1075 418"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M540.643 417.231C831.974 417.231 1068.14 401.596 1068.14 382.309C1068.14 363.023 831.974 347.388 540.643 347.388C249.313 347.388 13.1434 363.023 13.1434 382.309C13.1434 401.596 249.313 417.231 540.643 417.231Z"
        fill="#F2F2F2"
      />
      <path
        d="M520.426 0.00971985C434.482 0.00971985 372.775 55.1491 372.775 183.808C372.775 329.621 434.482 368.218 520.426 368.218C606.37 368.218 671.753 325.945 671.753 183.808C671.753 31.868 606.37 0.00971985 520.426 0.00971985ZM520.991 319.818C461.464 319.818 430.365 284.895 430.365 183.902C430.365 94.79 462.737 47.7972 522.264 47.7972C581.791 47.7972 614.163 78.6649 614.163 183.902C614.163 282.349 580.517 319.818 520.991 319.818Z"
        fill="#61973F"
      />
      <path
        d="M321.311 266.517H285.777V161.877C285.777 156.32 283.569 150.989 279.639 147.059C275.709 143.129 270.379 140.922 264.821 140.922H256.495C253.743 140.922 251.018 141.464 248.475 142.517C245.933 143.57 243.623 145.113 241.677 147.059C239.731 149.005 238.187 151.315 237.134 153.858C236.081 156.4 235.539 159.125 235.539 161.877V266.517H135.309C133.247 266.517 131.22 265.984 129.425 264.97C127.629 263.955 126.127 262.494 125.062 260.728C123.998 258.962 123.408 256.951 123.35 254.89C123.292 252.829 123.768 250.788 124.731 248.965L230.814 48.1844C232.136 45.6812 232.938 42.9359 233.17 40.1143C233.402 37.2927 233.061 34.4533 232.165 31.7675C231.27 29.0817 229.84 26.6051 227.961 24.4873C226.082 22.3695 223.793 20.6544 221.233 19.4455L214.971 16.4883C210.108 14.1921 204.549 13.853 199.444 15.5413C194.338 17.2296 190.077 20.8159 187.542 25.5583L58.1602 267.591C55.957 271.712 54.8043 276.314 54.8043 280.987V280.987C54.8043 284.719 55.5393 288.414 56.9673 291.861C58.3954 295.309 60.4885 298.441 63.1271 301.08C65.7658 303.719 68.8983 305.812 72.3459 307.24C75.7935 308.668 79.4885 309.403 83.2202 309.403H235.539V375.57C235.539 378.869 236.189 382.135 237.451 385.183C238.713 388.23 240.564 390.999 242.896 393.332C245.229 395.664 247.998 397.515 251.045 398.777C254.093 400.039 257.359 400.689 260.658 400.689H260.658C263.957 400.689 267.223 400.039 270.271 398.777C273.318 397.515 276.087 395.664 278.42 393.332C280.752 390.999 282.603 388.23 283.865 385.183C285.127 382.135 285.777 378.869 285.777 375.57V309.403H321.311C326.998 309.403 332.452 307.144 336.474 303.122C340.495 299.101 342.754 293.647 342.754 287.96V287.96C342.754 282.273 340.495 276.819 336.474 272.797C332.453 268.776 326.998 266.517 321.311 266.517V266.517Z"
        fill="#61973F"
      />
      <path
        d="M979.308 266.517H943.774V161.877C943.774 156.32 941.566 150.989 937.636 147.059C933.706 143.129 928.376 140.922 922.818 140.922H914.491C911.739 140.922 909.014 141.464 906.472 142.517C903.929 143.57 901.619 145.113 899.673 147.059C897.727 149.005 896.184 151.315 895.131 153.858C894.077 156.4 893.535 159.125 893.535 161.877V266.517H793.305C791.243 266.517 789.216 265.984 787.421 264.97C785.626 263.955 784.123 262.494 783.059 260.728C781.995 258.962 781.405 256.951 781.347 254.89C781.289 252.829 781.764 250.788 782.728 248.965L888.81 48.1844C890.133 45.6812 890.934 42.9359 891.167 40.1143C891.399 37.2928 891.057 34.4533 890.162 31.7675C889.266 29.0817 887.836 26.6051 885.957 24.4873C884.078 22.3695 881.79 20.6544 879.23 19.4455L872.967 16.4883C868.105 14.1921 862.546 13.853 857.44 15.5413C852.334 17.2296 848.073 20.8159 845.538 25.5583L716.157 267.591C713.953 271.712 712.801 276.314 712.801 280.987V280.987C712.801 288.523 715.795 295.751 721.124 301.08C726.453 306.409 733.68 309.403 741.217 309.403H893.535V375.57C893.535 382.232 896.182 388.621 900.893 393.332C905.603 398.043 911.992 400.689 918.654 400.689V400.689C925.316 400.689 931.706 398.043 936.416 393.332C941.127 388.621 943.773 382.232 943.773 375.57V309.403H979.308C984.995 309.403 990.449 307.144 994.47 303.122C998.492 299.101 1000.75 293.647 1000.75 287.96V287.96C1000.75 282.273 998.492 276.819 994.47 272.797C990.449 268.776 984.995 266.517 979.308 266.517Z"
        fill="#61973F"
      />
      <path
        d="M1006.86 252.55C1009.89 253.651 1013.14 254.034 1016.34 253.667C1019.54 253.301 1022.62 252.196 1025.32 250.439C1028.02 248.683 1030.28 246.322 1031.91 243.544C1033.55 240.766 1034.51 237.647 1034.74 234.431C1034.96 231.216 1034.43 227.992 1033.2 225.015C1031.96 222.038 1030.05 219.388 1027.62 217.275C1025.19 215.161 1022.3 213.642 1019.17 212.837C1016.05 212.032 1012.79 211.962 1009.64 212.634L1010.16 223.347L1005.09 214.166C1000.11 216.503 996.271 220.72 994.404 225.889C993.741 227.699 993.338 229.595 993.207 231.519C992.887 236.032 994.048 240.527 996.512 244.322C998.976 248.117 1002.61 251.006 1006.86 252.55V252.55Z"
        fill="#61973F"
      />
      <path
        d="M1031.94 376.793C1030.15 367.683 1037.9 359.606 1045.56 354.357C1053.22 349.107 1062.17 343.949 1064.78 335.04C1068.53 322.236 1057.35 310.51 1048.64 300.398C1042.19 292.894 1036.64 284.65 1032.12 275.841C1030.31 272.308 1028.64 268.615 1028.17 264.674C1027.48 258.999 1029.31 253.351 1031.14 247.938C1037.26 229.903 1043.8 212.02 1050.77 194.288"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1007.72 249.792C1010.75 250.893 1013.99 251.276 1017.2 250.909C1020.4 250.543 1023.47 249.438 1026.17 247.682C1028.88 245.925 1031.13 243.565 1032.77 240.787C1034.4 238.009 1035.37 234.889 1035.59 231.673C1035.82 228.458 1035.29 225.234 1034.06 222.257C1032.82 219.28 1030.91 216.63 1028.48 214.517C1026.04 212.403 1023.15 210.884 1020.03 210.079C1016.91 209.274 1013.64 209.204 1010.49 209.876L1011.01 220.589L1005.95 211.408C1000.97 213.745 997.128 217.962 995.262 223.131C994.599 224.941 994.196 226.837 994.064 228.761C993.745 233.274 994.905 237.769 997.369 241.564C999.833 245.359 1003.47 248.248 1007.72 249.792V249.792Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1029.4 190.588C1030.59 187.308 1032.58 184.38 1035.2 182.073C1037.82 179.767 1040.97 178.157 1044.38 177.391L1046.09 187.574L1049.27 176.879C1053.68 176.944 1057.96 178.41 1061.48 181.064C1065 183.718 1067.59 187.423 1068.87 191.645C1070.15 195.866 1070.06 200.386 1068.6 204.551C1067.15 208.715 1064.41 212.31 1060.78 214.815C1057.15 217.32 1052.81 218.607 1048.4 218.489C1043.99 218.371 1039.73 216.854 1036.24 214.158C1032.75 211.462 1030.21 207.726 1028.98 203.49C1027.74 199.253 1027.89 194.735 1029.4 190.588H1029.4Z"
        fill="#61973F"
      />
      <path
        d="M1030.54 186.911C1031.73 183.631 1033.72 180.703 1036.34 178.396C1038.96 176.09 1042.12 174.479 1045.52 173.713L1047.23 183.897L1050.41 173.201C1054.82 173.267 1059.1 174.732 1062.62 177.387C1066.15 180.041 1068.74 183.746 1070.02 187.968C1071.3 192.189 1071.2 196.709 1069.75 200.873C1068.29 205.038 1065.55 208.633 1061.92 211.138C1058.29 213.643 1053.96 214.93 1049.55 214.812C1045.14 214.694 1040.88 213.177 1037.38 210.481C1033.89 207.785 1031.35 204.049 1030.12 199.813C1028.89 195.576 1029.04 191.058 1030.54 186.911H1030.54Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1044.99 300.604C1049.8 302.347 1055.07 302.261 1059.82 300.363C1064.56 298.464 1068.44 294.886 1070.72 290.311C1072.99 285.735 1073.51 280.482 1072.16 275.553C1070.81 270.623 1067.7 266.362 1063.41 263.582L1060.97 271.801L1059.24 261.497C1059.22 261.489 1059.2 261.482 1059.18 261.477C1056.62 260.543 1053.89 260.125 1051.16 260.246C1048.42 260.367 1045.74 261.025 1043.27 262.182C1040.79 263.339 1038.56 264.973 1036.72 266.991C1034.87 269.008 1033.44 271.369 1032.51 273.94C1031.58 276.51 1031.16 279.238 1031.29 281.97C1031.41 284.701 1032.07 287.381 1033.23 289.857C1034.39 292.334 1036.02 294.557 1038.04 296.401C1040.06 298.245 1042.42 299.674 1044.99 300.604H1044.99Z"
        fill="#61973F"
      />
      <path
        d="M1045.98 296.88C1050.79 298.622 1056.06 298.536 1060.81 296.638C1065.55 294.74 1069.43 291.162 1071.71 286.586C1073.99 282.011 1074.5 276.758 1073.15 271.828C1071.8 266.899 1068.69 262.638 1064.4 259.857L1061.96 268.076L1060.23 257.772C1060.21 257.764 1060.19 257.758 1060.17 257.752C1057.61 256.818 1054.88 256.4 1052.15 256.521C1049.41 256.642 1046.73 257.3 1044.26 258.457C1041.78 259.615 1039.55 261.249 1037.71 263.266C1035.86 265.284 1034.43 267.645 1033.5 270.215C1032.57 272.785 1032.15 275.514 1032.28 278.245C1032.4 280.976 1033.06 283.656 1034.22 286.133C1035.38 288.609 1037.01 290.833 1039.03 292.677C1041.05 294.521 1043.41 295.949 1045.98 296.88H1045.98Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1023.32 335.167C1024.15 339.867 1026.57 344.14 1030.17 347.27C1033.77 350.4 1038.34 352.195 1043.11 352.356C1047.88 352.517 1052.56 351.032 1056.37 348.152C1060.17 345.272 1062.87 341.171 1064.01 336.537C1065.15 331.903 1064.66 327.018 1062.63 322.701C1060.59 318.384 1057.14 314.897 1052.84 312.826C1048.54 310.755 1043.66 310.225 1039.02 311.326C1034.37 312.426 1030.25 315.09 1027.33 318.87L1036.61 332.826L1023.94 325.418C1022.95 328.572 1022.74 331.915 1023.32 335.167V335.167Z"
        fill="#61973F"
      />
      <path
        d="M1024.18 332.409C1025.01 337.109 1027.42 341.382 1031.03 344.512C1034.63 347.642 1039.2 349.437 1043.97 349.598C1048.74 349.759 1053.42 348.274 1057.22 345.394C1061.03 342.514 1063.73 338.413 1064.87 333.779C1066.01 329.145 1065.52 324.26 1063.49 319.943C1061.45 315.626 1058 312.139 1053.7 310.068C1049.4 307.997 1044.52 307.467 1039.87 308.568C1035.23 309.668 1031.1 312.332 1028.19 316.112L1037.46 330.068L1024.79 322.661C1023.81 325.814 1023.6 329.157 1024.18 332.409V332.409Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M9.00746 303.249C10.9978 303.972 13.1289 304.224 15.2329 303.983C17.337 303.743 19.3563 303.017 21.1319 301.862C22.9075 300.708 24.3908 299.157 25.4648 297.332C26.5388 295.507 27.1742 293.457 27.3208 291.345C27.4675 289.232 27.1215 287.114 26.3101 285.158C25.4987 283.202 24.244 281.461 22.645 280.073C21.0459 278.684 19.1463 277.686 17.0957 277.157C15.0451 276.628 12.8997 276.582 10.8285 277.024L11.1707 284.062L7.84085 278.03C4.57278 279.566 2.04805 282.336 0.821494 285.732C0.385892 286.922 0.121078 288.167 0.034953 289.431C-0.17523 292.397 0.586979 295.35 2.20607 297.843C3.82517 300.337 6.2129 302.234 9.00746 303.249V303.249Z"
        fill="#61973F"
      />
      <path
        d="M25.4837 384.879C24.3083 378.893 29.4017 373.587 34.4329 370.138C39.464 366.689 45.3427 363.3 47.0593 357.446C49.5264 349.034 42.1776 341.33 36.4579 334.686C32.2144 329.756 28.5702 324.34 25.6016 318.551C24.311 316.278 23.4319 313.794 23.0049 311.215C22.5539 307.486 23.7519 303.775 24.9588 300.219C28.9794 288.37 33.2782 276.62 37.8551 264.969"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M9.57064 301.437C11.5609 302.16 13.6921 302.412 15.7961 302.171C17.9001 301.931 19.9195 301.205 21.6951 300.05C23.4707 298.896 24.9539 297.345 26.0279 295.52C27.1019 293.695 27.7373 291.645 27.884 289.533C28.0307 287.42 27.6847 285.302 26.8733 283.346C26.0618 281.39 24.8072 279.649 23.2081 278.261C21.6091 276.872 19.7094 275.874 17.6589 275.345C15.6083 274.816 13.4628 274.77 11.3916 275.212L11.7339 282.25L8.40403 276.218C5.13595 277.754 2.61122 280.524 1.38467 283.92C0.949069 285.11 0.684259 286.355 0.598129 287.619C0.387932 290.585 1.15014 293.538 2.76923 296.031C4.38833 298.525 6.77607 300.422 9.57064 301.437V301.437Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M23.8124 262.539C24.5935 260.384 25.9044 258.46 27.6244 256.945C29.3444 255.429 31.4181 254.371 33.6545 253.868L34.7803 260.559L36.8677 253.532C39.7659 253.575 42.5754 254.537 44.8907 256.281C47.206 258.025 48.9071 260.46 49.7486 263.233C50.5901 266.007 50.5283 268.976 49.5723 271.712C48.6162 274.449 46.8152 276.81 44.4295 278.456C42.0437 280.102 39.1966 280.948 36.2991 280.87C33.4016 280.793 30.6038 279.796 28.3095 278.025C26.0152 276.254 24.3432 273.799 23.5349 271.016C22.7265 268.232 22.8237 265.264 23.8124 262.539V262.539Z"
        fill="#61973F"
      />
      <path
        d="M24.5632 260.123C25.3443 257.968 26.6552 256.044 28.3752 254.529C30.0952 253.013 32.169 251.955 34.4053 251.452L35.5312 258.143L37.6186 251.116C40.5168 251.158 43.3263 252.121 45.6415 253.865C47.9568 255.609 49.658 258.044 50.4995 260.817C51.3409 263.591 51.2792 266.56 50.3231 269.296C49.367 272.033 47.5661 274.394 45.1803 276.04C42.7946 277.686 39.9474 278.532 37.0499 278.454C34.1525 278.377 31.3546 277.38 29.0603 275.609C26.7661 273.838 25.094 271.383 24.2857 268.599C23.4774 265.816 23.5746 262.848 24.5632 260.123V260.123Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M34.0576 334.822C37.214 335.967 40.6813 335.91 43.7987 334.663C46.9162 333.415 49.4656 331.065 50.9612 328.059C52.4568 325.052 52.7939 321.601 51.9083 318.362C51.0227 315.124 48.9763 312.324 46.1592 310.497L44.5553 315.897L43.418 309.127C43.4067 309.122 43.3951 309.118 43.3832 309.114C41.6948 308.5 39.9021 308.225 38.1073 308.304C36.3126 308.384 34.551 308.816 32.9234 309.576C31.2957 310.336 29.8338 311.41 28.6213 312.736C27.4088 314.061 26.4693 315.613 25.8567 317.301C25.2441 318.99 24.9703 320.783 25.0509 322.578C25.1315 324.373 25.565 326.134 26.3266 327.761C27.0882 329.388 28.163 330.849 29.4895 332.061C30.816 333.272 32.3683 334.21 34.0576 334.822V334.822Z"
        fill="#61973F"
      />
      <path
        d="M34.7081 332.374C37.8645 333.519 41.3319 333.463 44.4493 332.216C47.5667 330.968 50.1162 328.618 51.6118 325.611C53.1074 322.605 53.4445 319.154 52.5589 315.915C51.6733 312.676 49.6269 309.877 46.8098 308.05L45.2059 313.45L44.0685 306.68C44.0573 306.675 44.0457 306.67 44.0337 306.667C42.3458 306.055 40.5537 305.781 38.7599 305.861C36.9661 305.941 35.2057 306.374 33.5791 307.135C30.2941 308.671 27.7539 311.449 26.5172 314.858C25.2806 318.267 25.4488 322.028 26.9849 325.313C28.521 328.597 31.2991 331.138 34.7081 332.374V332.374Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M19.822 357.53C20.3647 360.618 21.9528 363.426 24.3198 365.482C26.6868 367.538 29.6889 368.718 32.8226 368.823C35.9562 368.929 39.0309 367.954 41.5309 366.061C44.0309 364.169 45.8042 361.475 46.5535 358.43C47.3027 355.385 46.9823 352.176 45.6459 349.339C44.3096 346.503 42.0386 344.212 39.2139 342.852C36.3891 341.491 33.1823 341.143 30.1314 341.866C27.0804 342.589 24.3708 344.339 22.457 346.822L28.5493 355.992L20.2249 351.125C19.5795 353.197 19.4413 355.393 19.822 357.53V357.53Z"
        fill="#61973F"
      />
      <path
        d="M20.3851 355.718C20.9278 358.806 22.5159 361.614 24.8829 363.67C27.25 365.726 30.252 366.906 33.3857 367.011C36.5194 367.117 39.594 366.142 42.094 364.249C44.594 362.357 46.3673 359.663 47.1166 356.618C47.8658 353.573 47.5454 350.364 46.2091 347.527C44.8727 344.691 42.6017 342.4 39.777 341.039C36.9522 339.679 33.7454 339.331 30.6945 340.054C27.6435 340.777 24.9339 342.527 23.0201 345.01L29.1124 354.18L20.788 349.313C20.1426 351.385 20.0044 353.581 20.3851 355.718V355.718Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
  );
};
export const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="#FFFFFF">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
    </svg>
  );
};

export const NoteIcon = () => {
  return (
    <svg style={style} viewBox="0 0 24 24">
      <path
        d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7h4v9a3 3 0 0 1-3 3zm-1-10v7a1 1 0 0 0 2 0v-7h-2zM5 6v6h6V6H5zm0 7v2h10v-2H5zm0 3v2h10v-2H5zm2-8h2v2H7V8z"
        fill="currentColor"></path>
    </svg>
  );
};
